<div (click)="productSelected.emit(product()!)" class="product-card border p-3 cursor-pointer position-relative">
  <div class="d-flex gap-3 align-items-start">
    @if (showCheckbox()) {
      <input (click)="$event.stopPropagation()" [id]="product()?.id" type="checkbox" class="form-check-input mt-1" />
    }

    <div class="flex-fill">
      <div class="d-flex justify-content-between align-items-start">
        <h5 class="fw-500 mb-1">{{ product()?.code }}</h5>
        <button
          class="stretched-link px-2 btn btn-primary rounded-3 btn-sm d-flex align-items-center gap-2 btn-h35 ms-auto"
        >
          <i class="bi bi-link-45deg lh-1"></i> <span>Link</span>
        </button>
      </div>
      <p class="text-muted small mb-0">{{ product()?.description }}</p>
      <p class="text-muted small mb-0">{{ product()?.subcategory?.category?.description }}</p>
      <p class="text-muted small mb-0">{{ product()?.subcategory?.description }}</p>
      <!-- <div class="d-flex gap-2 pt-1">

      <div class="d-flex gap-2 pt-1">
        <span class="badge bg-secondary fw-500">Drawers</span>
        <span class="badge border fw-500 text-dark">Group 2</span>
      </div> -->
    </div>
    <!-- <label [for]="product()?.id" class="stretched-link" aria-hidden="true" role="button"></label> -->
  </div>
</div>
